export const isDateStringOrNumber = (value: any) => {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    value instanceof Date
  );
};
